import { useState } from 'react';
import type { VideoSource } from '../../../../shared/protocol';

export function GenericIframePlayer({ source }: { source: Extract<VideoSource, { provider: 'iframe' }> }) {
  const [blocked, setBlocked] = useState(false);
  return (
    <>
      <div className="video-frame" aria-label="Conteúdo externo incorporado">
        <iframe
          className="video-embed external-iframe"
          src={source.mediaUrl}
          title="Conteúdo externo"
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture"
          allowFullScreen
          referrerPolicy="strict-origin-when-cross-origin"
          onError={() => setBlocked(true)}
        />
        {blocked && <div className="player-notice" role="status">Este site não permite incorporação dentro do Watch Together.</div>}
      </div>
      <div className="provider-note">
        <span>{blocked ? 'A origem recusou o carregamento do iframe.' : 'Este conteúdo pode ser incorporado, mas o player não fornece uma API de sincronização ao Watch Together.'}</span>
        {!blocked && <span>Se o conteúdo não carregar, a origem pode bloquear incorporação.</span>}
        <a href={source.mediaUrl} target="_blank" rel="noreferrer">Abrir origem</a>
      </div>
    </>
  );
}
